import "./navbar.scss";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Link, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import { DarkModeContext } from "../../context/darkModeContext";
import { AuthContext } from "../../context/authContext";
import Logout from "../logout/Logout";
import { getImageUrl } from "../../utils/getImageUrl"


const NavBar = () => {
  const { toggle, darkMode } = useContext(DarkModeContext);
  const { currentUser } = useContext(AuthContext);
  const [ showLogout, setShowLogout ] = useState(false);
  const location = useLocation();

  const scrollToTop = () => {
    const contentArea = document.querySelector('.content-area');
    if (contentArea) {
      contentArea.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleHomeClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      scrollToTop();
    }
  };

  const handleProfileClick = (e) => {
    if (location.pathname === `/profile/${currentUser.id}`) {
      e.preventDefault();
      scrollToTop();
    }
  };
  
  return (
    <div className="navbar">
      <div className="left">
        <Link to="/" onClick={handleHomeClick} style={{ textDecoration: "none" }}>
          <span>Social App</span>
        </Link>
        <Link to="/" onClick={handleHomeClick}>
          <HomeOutlinedIcon />
        </Link>
        {darkMode ? (
          <WbSunnyOutlinedIcon onClick={toggle} />
        ) : (
          <DarkModeOutlinedIcon onClick={toggle} />
        )}
        <LogoutOutlinedIcon onClick={() => setShowLogout(true)}/>
        <div className="search">
          <SearchOutlinedIcon />
          <input type="text" placeholder="Search..." />
        </div>
      </div>
      <div className="right">
        <div className="notification">
          <PersonOutlinedIcon />
          <div className="messenger-link">
            <Link to={"/messenger"} style={{ textDecoration: "none" }}>
                <EmailOutlinedIcon />
            </Link>
          </div>
          <NotificationsOutlinedIcon />
        </div>

        <div className="user">
          <Link to={"/profile/" + currentUser.id} onClick={handleProfileClick} style={{ textDecoration: "none" }}>
          {currentUser.profilePic === null?
            <img
              src={"/defaultProfile.jpg"}
              alt=""
            />
              :
            <img
              src={getImageUrl("profile", currentUser.profilePic)}
              alt=""
            />
          }
          <span>{currentUser.name}</span>
          </Link>
        </div>
      </div>
      {showLogout && <Logout setShowLogout={setShowLogout} />}
    </div>
  );
};

export default NavBar;
